module.exports = __webpack_public_path__ + "media/application/images/svgs/icons/star-7132143d91a7e032e0de117e76400357.svg";